<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      date-time-end
      date-time-start
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>

      <el-table-column
        fixed="right"
        label="留言回复"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row, 'replay')"
            type="text"
            size="mini"
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            @click="showDialogContent(scope.row, 'details')"
            type="text"
            size="mini"
          >
            详情
          </el-button>
          <el-button @click="handleSelect(scope.row)" type="text" size="mini">
            设置回复人
          </el-button>
          <el-button @click="handleReply(scope.row)" type="text" size="mini">
            回复
          </el-button>

          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--添加/修改工作计划-->
    <el-dialog
      title="添加/修改工作计划"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="计划日期" prop="appointDate" label-width="100px">
          <el-date-picker
            v-model="form.workDate"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="计划内容" prop="appointDate" label-width="100px">
          <el-input
            v-model="form.content"
            size="medium"
            autosize
            placeholder="请输入计划内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择问题回复人"
      :close-on-click-modal="false"
      :visible.sync="dialogSelectVisible"
    >
      <el-row>
        <div>
          <el-col :span="4" :offset="4">
            <p class="demonstration ">问题回复人:</p>
          </el-col>
          <el-col :span="8">
            <el-select
              v-model="modalMessage"
              multiple
              placeholder="请选择"
              @remove-tag="handleRemove(1, $event)"
              @visible-change="handleChange(1, $event)"
            >
              <el-option
                v-for="item in options"
                :key="item.uid"
                :label="item.name"
                :value="item.uid"
              ></el-option>
            </el-select>
          </el-col>

          <el-button type="primary" @click="dialogSelectConfirm">
            确 定
          </el-button>
        </div>
      </el-row>
    </el-dialog>
    <!-- 回复留言 -->
    <el-dialog
      title="留言回复"
      :close-on-click-modal="false"
      :visible.sync="replayFlag"
    >
      <el-form
        :model="replayform"
        :rules="replayRules"
        ref="replayform"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item
          label="回复内容"
          style="text-align: left"
          prop="reply"
          label-width="100px"
        >
          <el-input
            v-model="replayform.reply"
            size="medium"
            type="textarea"
            placeholder="请输入回复内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图片"
          style="text-align: left"
          prop="image"
          label-width="100px"
        >
          <div style="display:flex;">
            <div v-for="(item, index) in replayform.images" class="img-list">
              <img v-if="item" :src="serverUrl + item" class="avatar" />
              <div @click="deleteImg(index)">
                <i class="el-icon-delete" style="cursor: pointer;"></i>
              </div>
            </div>
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="imgDefault"
            >
              <i
                v-if="replayform.images.length < 3"
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="replayFlag = false">取 消</el-button>
        <el-button type="primary" @click="replayConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :visible.sync="dialogContentMsgVisible"
    >
      <Details :detail="dialogMsgContent" :type="'msg'"></Details>
      <!-- <div v-if="dialogContent.length != 0" style="text-align: left">
        <el-timeline :reverse="false">
          <el-timeline-item
            v-for="(item, index) in dialogContent"
            placement="top"
          >
            <el-card style="position:relative;">
              <i
                class="el-icon-delete right-top-del"
                style="cursor: pointer;position: absolute;"
                @click="delMsg(item.uid)"
              ></i>

              <p>{{ item.content }}</p>
              <div style="display:flex;margin-top: 10px;">
                <img
                  v-for="k in item.images"
                  class="avatar"
                  :src="serverUrl + k"
                  alt=""
                />
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div v-else>暂无回复</div> -->
    </el-dialog>
    <el-dialog
      title="留言回复列表"
      :close-on-click-modal="false"
      :visible.sync="dialogContentVisible"
    >
      <div v-if="dialogContent.length != 0" style="text-align: left">
        <el-timeline :reverse="false">
          <el-timeline-item
            v-for="(item, index) in dialogContent"
            :timestamp="item.createTime"
            placement="top"
          >
            <el-card style="position:relative;">
              <i
                class="el-icon-delete right-top-del"
                style="cursor: pointer;position: absolute;"
                @click="delMsg(item.uid)"
              ></i>
              <h4>{{ item.replier }}</h4>
              <p>{{ item.content }}</p>
              <div style="display:flex;margin-top: 10px;">
                <img
                  v-for="k in item.images"
                  class="avatar"
                  :src="serverUrl + k"
                  alt=""
                />
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div v-else>暂无回复</div>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from "@/assets/http/utils"
import Details from "@/components/details/index"
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"

export default {
  name: "messageManager",
  components: {
    Details,
  },
  data() {
    let Self = this

    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,
      replayFlag: false,
      // 搜索栏初始化
      searchForm: {
        startDate: "",
        endDate: "",
      },

      // 表头初始化
      tableHeader: {
        name: "留言人",
        mobile: "手机号",
        createTime: "留言时间",
        content: "留言内容",
      },

      // 表格数据
      tableData: [],
      modalMessage: "",
      options: [],
      // dialog可见性
      dialogFormVisible: false,
      dialogContentVisible: false,
      dialogSelectVisible: false,
      dialogContent: "",
      uid: "",
      // 新增表单
      form: {
        uid: "",
        workDate: "",
        content: "",
      },
      replayform: {
        uid: "",
        reply: "",
        images: [],
      },
      imgArr: [], //bannar图  多张
      serverUrl: apiUrl.ServerUrl,
      uploadAvatarServer: apiUrl.UploadFile,
      bannarImgUrl: "",
      // 表单验证规则
      rules: {
        workDate: {
          required: true,
          message: "请输入工作内容",
          trigger: "blur",
        },
        content: {
          required: true,
          message: "请输入工作内容",
          trigger: "blur",
        },
      },
      replayRules: {
        reply: {
          required: true,
          message: "请输入回复内容",
          trigger: "blur",
        },
      },
      dialogContent: {},
      // 控制详情弹窗
      dialogContentMsgVisible: false,
      dialogMsgContent: {},
    }
  },
  methods: {
    /*请求数据*/
    getData() {
      this.request({
        url: "/manager/message/findMessageList",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          startDate: this.searchForm.startDate,
          endDate: this.searchForm.endDate,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages

          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    //上传单位图片成功的回调
    handleBannarSuccess(res) {
      // this.form.images = res.data.url
      this.imgArr.push(res.data.url)
    },

    /*更改单页数据数量*/
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转*/
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*回复留言*/
    handleReply(rowData) {
      this.replayFlag = true
      this.replayform.uid = rowData.uid
      this.replayform.reply = ""
      this.replayform.images = []
    },
    replayConfirm() {
      console.log(this.replayform.images)
      // console.log(this.replayform.images.toString())
      // this.replayform.images = this.replayform.images.join(",")
      console.log(this.replayform.images)
      this.$refs.replayform.validate(valid => {
        if (valid) {
          this.request({
            url: "/manager/message/replyMessage",
            data: {
              uid: this.replayform.uid,
              reply: this.replayform.reply,
              images: this.replayform.images,
            },
            method: "post",
          })
            .then(res => {
              if (res.data.status === "BAD_REQUEST") {
                this.$message.warning(res.data.message)
              }
              this.replayFlag = false
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      })
    },
    // 删除图片
    imgRemove(index) {
      // debugger
      this.imgArr.splice(index, 1)
    },
    // 删除回复的留言
    delMsg(uid) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/message/deleteReplyMessage",
            params: {
              uid: uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.dialogContentVisible = false
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*查看回复人*/
    handleSelect(rowData) {
      this.dialogSelectVisible = true
      this.modalMessage = ""
      this.request({
        url: "/manager/message/getSettings",
        params: {
          uid: rowData.uid,
        },
        method: "GET",
      })
        .then(res => {
          this.modalMessage = res.data.data
          this.uid = rowData.uid
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*添加商户前的处理
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除*/
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/message/deleteMessage",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")

              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交*/
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.request({
            url: "/manager/message/replyMessage",
            data: {
              uid: this.form.uid,
              reply: this.form.reply,
            },
            method: "post",
          })
            .then(res => {
              this.$message.success("操作成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
          this.dialogFormVisible = false
        }
      })
    },

    /*dialog取消*/
    dialogCancel() {
      this.dialogFormVisible = false
      this.form = {}
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    showDialogContent(row, type) {
      if (type == "replay") {
        this.dialogContentVisible = true
      } else {
        this.dialogContentMsgVisible = true
      }

      this.request({
        url: "/manager/message/messageDetails",
        params: {
          uid: row.uid,
        },
        method: "get",
      })
        .then(res => {
          // 回复内容
          this.dialogContent = res.data.data.replyVoList
          // 详情
          this.dialogMsgContent = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    handleChange(index, value) {
      // if (this.uids.length === 0) return;
      // this.request({
      //     method: 'get',
      //     url: "/manager/special_function/getSettings",
      // }).then(res => {
      //     this.modalMessage = res.data.data;
      // }).catch(err => {
      //     this.$message.error(err.message)
      //
      // })
    },
    // 审核人员列表
    getCommunityList(times) {
      this.tableLoading = true
      this.request({
        method: "get",
        url: "/manager/special_function/getCommunityMember",
      })
        .then(res => {
          this.options = res.data.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // 上传留言的图片
    imgDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e)
      tmpFile.append("folder", "notify")
      Axios.post(apiUrl.server + "/manager/upload/uploadFile", tmpFile)
        .then(res => {
          this.replayform.images.push(res.data)
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    deleteImg(ind) {
      this.replayform.images.splice(ind, 1)
    },

    /*dialog提交*/
    dialogSelectConfirm() {
      this.$confirm("是否确认更改问题接收人?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true
          this.request({
            method: "post",
            url: "/manager/message/selectCommunityMember",
            params: {
              uid: this.uid,
              uids: this.modalMessage + "",
            },
          })
            .then(res => {})
            .catch(err => {})
          this.$message({
            type: "success",
            message: "更改成功!",
          })
          this.dialogSelectVisible = false
        })
        .catch(() => {
          this.getThirdAuth()
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    handleRemove(index, value) {
      this.tableLoading = true
      setTimeout(() => {
        this.request({
          method: "post",
          url: "/manager/special_function/newsAuditor",
          noLoading: true,
          params: {
            uids: this.modalMessage + "",
          },
          success: data => {
            this.tableLoading = false
            this.$message({
              type: "success",
              message: "回复人设置成功",
            })
          },
          error: e => {
            this.tableLoading = false
            this.$message.error(e.message)
          },
        })
      })
    },
  },

  mounted() {
    this.getData()
    this.getCommunityList()
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 10px;
}
.img-list {
  text-align: center;
}
.right-top-del {
  top: 10px;
  right: 10px;
}
</style>
